<template>
  <div class="h-full">
    <div class="flex items-center justify-center px-10 my-10"
    ref="deliveryHeading">
      <div>
        <img
          class="h-32 rounded-md object-contain"
          :src="
            menu.picture_url
              ? menu.picture_url
              : require('../assets/images/Menu.Logo.png')
          "
          alt="Logo"
        />
      </div>
      <div class="text-lg text-white ml-6">
        <p>
          QR MENU APP
        </p>
        <p class=" text-xl"
        :style="makeStyles(hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
        >
          {{ menu["name" + "_" + language] }}
        </p>
      </div>
    </div>
    <div
      class="bg-white rounded-t-xxl px-4 flex flex-col justify-start items-center self-center h-full pb-10"
    :style="makeStyles(hasKiosk && mainSectionTopRadius , customScreenHeigth)"
    >
      <div
        class="mt-8 mb-8 text-2xl md:text-3xl text-product-gray font-bold flex items-center text-center"
      >
        <p>{{ lang["what_to_eat"][this.language] }}</p>
      </div>

      <div class="flex mb-8 flex-row flex-wrap justify-center">
        <a
          @click="
            [
              $router
                .push({
                  path: `/${currentHash}/sub/category/${menuCategories[0].Id}`,
                })
                .catch(() => {}),
              
              getCategories(menuCategories[0]),
              $store.commit(
                'updateCurrentKioskMode',
                lang['Delivery'][language]
              ),
              addLocalstorage(),
            ]
          "
          class=" bg-primary-100 w-40 md:w-64  text-new-primary font-semibold text-center text-2xl flex flex-col justify-center items-center rounded-xl md:py-20 p-2 ml-2 mb-2"
          href="#"
        >
          <IconHome 
          classes="w-16 md:w-20 mb-2"
          stroke="#9D9D9D"
          />
          {{ lang["Delivery"][this.language] }}</a
        >
        <a
          @click="
            [
              $router
                .push({
                  path: `/${currentHash}/sub/category/${menuCategories[0].Id}`,
                })
                .catch(() => {}),
              getCategories(menuCategories[0]),
              $store.commit(
                'updateCurrentKioskMode',
                lang['take_away'][language]
              ),
              removeLocalstorage(),
            ]
          "
          class="bg-primary-100 w-40 md:w-64  text-new-primary font-semibold text-center text-2xl flex flex-col justify-center items-center rounded-xl ml-2 mb-2"
          href="#"
        >
        <IconTruck
            class="w-16 md:w-20 mb-2"
        />
          <p class="text-md">{{ lang["take_away"][this.language] }}</p></a
        >
      </div>
      <div>
        <LanguageModal />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import LanguageModal from "../components/LanguageModal";
import IconHome from "../components/icons/iconHome.vue";
import IconTruck from "../components/icons/iconTruck.vue";
export default {
  data() {
    return {
      lang: lang,
      customScreenHeigth: {}
    };
  },
  components: { LanguageModal, IconHome, IconTruck },
  computed: {
    ...mapGetters(["language","infiniteScroll", "menu","hasKiosk", "currentHash", "menuCategories"]),
    ...mapGetters("Cart", ["homeDelivery"]),
    ...mapGetters("Theme", ["mainSectionTopRadius","titleFont","titleTextTransform"]),
  },
  methods: {
    // get the categories and the subcategories (if there are any)
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        // if(this.infiniteScroll){
        //   this.$store.dispatch("GET_ALL_MENU_ITEMS");
        // }else{
        //   this.$store.dispatch("GET_CATEGORY");
        // }
          this.$store.dispatch("GET_CORRECT_MENU_ITEMS");

        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
    // removes the delivery option and add the take_away option
    removeLocalstorage() {
      localStorage.removeItem("delivery");
      localStorage.setItem("currentOption", "take_away");
      this.$store.commit("Cart/updateHomeDelivery", false);
    },
    // Add the take_away option
    addLocalstorage() {
      localStorage.setItem("delivery", true);
      localStorage.setItem("currentOption", "Delivery");
      this.$store.commit("Cart/updateHomeDelivery", true);
    },
    getHeightOfHeading() {
      let _headingHeight = this.$refs.deliveryHeading.clientHeight + 80 + 'px'; // ref element has class 'my-10' = 80px
      let calcHeight = `calc(100vh - ${_headingHeight})`;
      // Add the our calc to :style
      this.$set(this.customScreenHeigth, 'height', calcHeight)
    }
  },
  created() {
    // update the menuHash and get the items
    this.$store.commit("updateCurrentHash", this.$route.params.menuHash);
    this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    this.$store.commit("updateCurrentHash", this.$route.params.menuHash);
    // if(this.infiniteScroll){
    //   this.$store.dispatch("GET_ALL_MENU_ITEMS");
    // }else{
    //   this.$store.dispatch("GET_MENU_ITEMS");
    // }
    this.$store.dispatch("GET_CORRECT_MENU_ITEMS");

  },
  updated() {
    if (!this.language && !localStorage.getItem("language")) {
      this.$store.commit("changeLanguage", this.menu.language);
    } else {
      this.$store.commit("changeLanguage", localStorage.getItem("language"));
    }

    this.getHeightOfHeading(); // get the height of the header

  },
};
</script>

<style></style>
